var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bouton"},[_c('v-btn',{staticClass:"button",class:{
      'purple-verion': _vm.btnType === 'order',
      'orange-version': _vm.btnType === 'install',
      'primary-version': _vm.btnType === 'connexion',
      'blueLight-version': _vm.btnType === 'cancel',
      'white-version theme-btn with-border': _vm.btnType === 'sendMail',
      'pink-lowercase-version ': _vm.btnType === 'initialize',
      'orange-dark-version ': _vm.btnType === 'compare',
      bigHeight: _vm.hasBigHeight,
      'green-version': _vm.status === 'En ligne',
      'orange-no-shadow-version': _vm.status === 'En mise à jour',
      'grey-version': _vm.status === 'Hors ligne',
      isDisabled: _vm.isDisabled,
      'purple-empty-version': _vm.btnType === 'overview',
      'orange-alt-version': _vm.btnType === 'edit',
      'purple-light-version': _vm.btnType === 'save',
    },attrs:{"rounded":_vm.btnForm,"elevation":_vm.elevation},on:{"click":_vm.click}},[_c('span',{class:{
        'text-grey-color': _vm.labelColor === 'grey',
        'white-label': !_vm.labelColor,
        'pink-label ': _vm.labelColor === 'pink',
        'purple-dark-label': _vm.labelColor === 'purple-dark',
      }},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),(_vm.icon !== '')?_c('v-icon',{staticClass:"material-icons-outlined pa-1",attrs:{"color":_vm.iconColor}},[_vm._v("\n      "+_vm._s(_vm.icon)+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }